import Control from "./Control.js"

export default class Fullscreen extends Control {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-fullscreen", true)
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onfullscreenchange(event) {
    const key = (event.detail) ? "MSG_EXIT_FULLSCREEN" : "MSG_ENTER_FULLSCREEN"
    this.setState({altText: key})
  }

  onClick() {
    if (this.player.displayState == "normal") {
      this.player.enterFullScreen()
    } else {
      this.player.exitFullScreen()
    }
  }
}
